import { createAction } from 'typesafe-actions';

import { IOption } from 'shared/components/Select/models/Option';
import { EPriceType } from 'shared/types/filters/priceType';

export const changePriceTypeAction = createAction(
  'filters/priceTypeChanged',
  (option: IOption<EPriceType>) => option.value,
)<EPriceType>();
